import {
  AudioItemValue, DataSource, MediaItemValue, SketchItemValue, VideoItemValue,
} from '@fulcrumapp/fulcrum-core';
import { DisplayableItem } from './media-displayer';
import photoDisplayer from './photo-displayer';
import videoDisplayer from './video-displayer';
import audioDisplayer from './audio-displayer';
import metadataLoaderForItem from './metadata-loader-for-item';
import sketchDisplayer from './sketch-displayer';

export default function displayableItemForItem(item: MediaItemValue, dataSource: DataSource): DisplayableItem {
  const base = {
    item,
    displayer: photoDisplayer,
    loadMetadata: metadataLoaderForItem(item, dataSource),
    supportsMapView: true,
  };

  if (item instanceof VideoItemValue) {
    return {
      ...base,
      displayer: videoDisplayer,
    };
  }
  if (item instanceof AudioItemValue) {
    return {
      ...base,
      displayer: audioDisplayer,
    };
  }

  if (item instanceof SketchItemValue) {
    return {
      ...base,
      supportsMapView: false,
      displayer: sketchDisplayer,
    };
  }
  return base;
}
